import React, { useState } from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
interface QuoteModalProps {
  totalPrice: number;
  onClose: () => void;
}
export const QuoteModal = ({
  totalPrice,
  onClose
}: QuoteModalProps) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real implementation, this would send the data to the server
    setIsSubmitted(true);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-78">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-auto" data-id="element-79">
        <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-80">
          <h2 className="text-xl font-semibold" data-id="element-81">Saa pakkumine</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors" data-id="element-82">
            <XIcon size={20} data-id="element-83" />
          </button>
        </div>
        {isSubmitted ? <div className="p-6 flex flex-col items-center" data-id="element-84">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-85">
              <CheckIcon size={32} className="text-green-500" data-id="element-86" />
            </div>
            <h3 className="text-lg font-medium mb-2" data-id="element-87">Pakkumine saadetud!</h3>
            <p className="text-gray-500 text-center mb-4" data-id="element-88">
              Pakkumine on saadetud teie e-posti aadressile. Täname teid huvi
              eest!
            </p>
            <button onClick={onClose} className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-md transition-colors" data-id="element-89">
              Sulge
            </button>
          </div> : <form onSubmit={handleSubmit} className="p-6" data-id="element-90">
            <div className="mb-6" data-id="element-91">
              <p className="text-gray-700 mb-4" data-id="element-92">
                Teie valikute põhjal genereeritakse PDF-pakkumine, mis
                saadetakse teie e-posti aadressile.
              </p>
              <div className="bg-gray-50 p-4 rounded-md mb-4" data-id="element-93">
                <div className="text-sm text-gray-500" data-id="element-94">KOGUMAKSUMUS</div>
                <div className="text-2xl font-bold" data-id="element-95">
                  {totalPrice.toLocaleString()} €
                </div>
              </div>
            </div>
            <div className="space-y-4" data-id="element-96">
              <div data-id="element-97">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-98">
                  Nimi
                </label>
                <input id="name" type="text" value={name} onChange={e => setName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500" required data-id="element-99" />
              </div>
              <div data-id="element-100">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-101">
                  E-posti aadress
                </label>
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500" required data-id="element-102" />
              </div>
              <div data-id="element-103">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-104">
                  Telefon
                </label>
                <input id="phone" type="tel" value={phone} onChange={e => setPhone(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500" data-id="element-105" />
              </div>
            </div>
            <div className="mt-6" data-id="element-106">
              <button type="submit" className="w-full bg-orange-500 hover:bg-orange-600 text-white px-4 py-3 rounded-md transition-colors font-medium" data-id="element-107">
                Saada pakkumine
              </button>
            </div>
          </form>}
      </div>
    </div>;
};